import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
    selector: "app-tile-count",
    templateUrl: "./tile-count.component.html",
    styleUrls: ["./tile-count.component.scss"],
    standalone: false
})
export class TileCountComponent {
  @Input() title = "No Title";
  @Input() count = "0";
  @Input() color = "#ccc";
  @Output() tileClick: EventEmitter<any> = new EventEmitter();

  tileClicked(): void {
    this.tileClick.emit(true);
  }
}
